/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Rep_HypertrophyInputs */

const en_us2_progress_extra_rep_hypertrophy = /** @type {(inputs: Progress_Extra_Rep_HypertrophyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6–12 · hypertrophy`)
};

const pt_br2_progress_extra_rep_hypertrophy = /** @type {(inputs: Progress_Extra_Rep_HypertrophyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6–12 · hipertrofia`)
};

const es_419_progress_extra_rep_hypertrophy = /** @type {(inputs: Progress_Extra_Rep_HypertrophyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6–12 · hipertrofia`)
};

const pt_pt2_progress_extra_rep_hypertrophy = /** @type {(inputs: Progress_Extra_Rep_HypertrophyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6–12 · hipertrofia`)
};

const fr_fr2_progress_extra_rep_hypertrophy = /** @type {(inputs: Progress_Extra_Rep_HypertrophyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6–12 · hypertrophie`)
};

const de_de2_progress_extra_rep_hypertrophy = /** @type {(inputs: Progress_Extra_Rep_HypertrophyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6–12 · Hypertrophie`)
};

const it_it2_progress_extra_rep_hypertrophy = /** @type {(inputs: Progress_Extra_Rep_HypertrophyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`6–12 · ipertrofia`)
};

/**
* | output |
* | --- |
* | "6–12 · hypertrophy" |
*
* @param {Progress_Extra_Rep_HypertrophyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_rep_hypertrophy = /** @type {((inputs?: Progress_Extra_Rep_HypertrophyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Rep_HypertrophyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_rep_hypertrophy(inputs)
	if (locale === "es-419") return es_419_progress_extra_rep_hypertrophy(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_rep_hypertrophy(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_rep_hypertrophy(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_rep_hypertrophy(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_rep_hypertrophy(inputs)
	return en_us2_progress_extra_rep_hypertrophy(inputs)
});
export { progress_extra_rep_hypertrophy as "progress-extra.rep_hypertrophy" }